import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { animateFadeIn } from './fade-in-animate';
import { animateSlideLeft } from './slide-left-animate';
import { animateSlideRight } from './slide-right-animate';

export const initAnimations = () => {
  gsap.registerPlugin(ScrollTrigger);
  animateFadeIn();
  animateSlideLeft();
  animateSlideRight();
};
